import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class HttpClientWrapperService {
  private blockSubject = new BehaviorSubject<any>(false); // Default value can be false or any initial value
  public block = this.blockSubject.asObservable();  // Observable for block
  version : any = localStorage.getItem('version');

  setBlock(value: boolean): void {
    this.blockSubject.next(value);  // Emit new block value
  }

  constructor(
    private httpClient: HttpClient,
    private auth: AuthService
  ) { }

  get(path): Observable<any> {
    const header = new HttpHeaders()
      .set('Authorization', 'Bearer ' + this.auth.getToken());
    const options = { headers: header };
    return this.httpClient.get(path, options);
    // return this.httpClient.get(path);
  }

  post(path, body): Observable<any> {
    const header = new HttpHeaders()
      .set('Authorization', 'Bearer ' + this.auth.getToken());
    const options = { headers: header };
    return this.httpClient.post(path, body, options);
    // return this.httpClient.post(path, body);
  }

  put(path, body): Observable<any> {
    const header = new HttpHeaders()
      .set('Authorization', 'Bearer ' + this.auth.getToken());
    const options = { headers: header };
    return this.httpClient.put(path, body, options);
    // return this.httpClient.put(path, body);
  }

  // Delete method with the body appended to the options of the request
  delete(path, body?): Observable<any> {
    const header = new HttpHeaders()
      .set('Authorization', 'Bearer ' + this.auth.getToken());
    const options = { headers: header };
    return this.httpClient.delete(path, options);
    // return this.httpClient.delete(path);
  }

}
